<div class="ula-chart" *ngIf="data">
  <div class="ula-chart-scroll">
    <div #ulaHost [id]="$any(data).widgetId" class="ula-chart-host"
      [style.height]="hostHeight" [style.width.px]="chartWidthPx"></div>
  </div>
</div>
